import styled from 'styled-components';
import { Box, Stack, Typography } from '@mui/material';

const figmaShadow = `
  0px 20px 25px -5px rgba(0, 0, 0, 0.1), 
  0px 10px 10px -5px rgba(0, 0, 0, 0.04)
`;

interface StyledAlertBoxProps {
    bgColor: string;
    isTitle?: boolean;
}

export const StyledAlertBox = styled(Box) <StyledAlertBoxProps>`
  width: 360px;
  min-height: 84px;
  border-radius: 8px;
  padding: 16px;
  gap: 16px; 
  
  background-color: ${props => props.bgColor};
  box-shadow: ${figmaShadow};
  
  display: flex;
  flex-direction: row;
  align-items: flex-start;
`;

export const ContentStack = styled(Stack)`
  flex-grow: 1;
`;

interface StyledTextProps {
    mainColor: string;
    isTitle?: boolean;
}

export const StyledText = styled(Typography) <StyledTextProps>`
  color: ${props => props.mainColor};
  font-family: 'Inter'; 
  font-size: 16px;
  line-height: 24px;
  
   font-weight: ${props => (props.isTitle ? '700 !important' : '400 !important')}; 

`;

interface StyledIconProps {
    mainColor: string;
    isClose?: boolean;
}

export const StyledIcon = styled.div<StyledIconProps>`
  color: ${props => props.mainColor};
  font-size: 24px;
  flex-shrink: 0;
  
  ${props => props.isClose && `
    cursor: pointer;
    margin-left: 16px;
  `}
`;